<template>
  <div class="h-full / flex flex-col gap-2 items-center justify-center / bg-gray-900 text-white text-xs cursor-default">
    <CodeBracketIcon class="h-5 w-5" />
    <div v-if="slide.content_url" class="whitespace-normal text-center min-w-0 inline-block w-full px-4">
      <p data-testid="url-slide-url" class="truncate mb-0">
        {{ displayUrl }}
      </p>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { DeepReadonly, PropType } from 'vue'
import { CodeBracketIcon } from '@heroicons/vue/24/outline'
import type { Slide } from '@/entities/deck'

const props = defineProps({
  slide: {
    type: Object as PropType<DeepReadonly<Slide>>,
    required: true,
  },
})

const displayUrl = computed(() => {
  try {
    const url = new URL(props.slide.content_url!)
    const doesPathNameExist = url.pathname !== '/'

    return `${url.hostname}${doesPathNameExist ? url.pathname : ''}`
  } catch {
    return props.slide.content_url
  }
})
</script>
